import { Stack, styled } from '@mui/material'
import { CSSProperties } from 'react'
import { transientOptions } from 'styles/TransientOptions'

const ZKTabWrap = styled(Stack)`
  flex-direction: row;
  width: 100%;
`
const ZKTabItem = styled('div', transientOptions)<{
  $active?: boolean
}>`
  display: flex;
  align-items: center;
  color: ${({ $active }) =>
    $active ? 'rgba(255, 255, 255, 1)' : 'rgba(149, 164, 173, 1)'};
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  cursor: ${({ $active }) => ($active ? 'default' : 'pointer')};
  position: relative;
  transition: all 0.2s ease-in-out;

  ${(props) => props.theme.breakpoints.down('md')} {
    font-size: 14px;
    white-space: nowrap;
  }

  &::after {
    content: '';
    opacity: ${({ $active }) => ($active ? 1 : 0)};
    width: 20px;
    height: 3px;
    background: rgba(160, 238, 9, 1);
    border-radius: 2px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`

export interface IZKTabRow {
  label: string
  value: any
}
interface IProps {
  tabs: Array<IZKTabRow>
  tabClick?: (row: IZKTabRow) => void
  activeValue: any
  wrapStyle?: CSSProperties
  customTabItem?: (row: IZKTabRow) => any
  itemStyle?: CSSProperties
  activeKey?: keyof IZKTabRow
  activeItemStyle?: CSSProperties
  // itemActiveStyle?: CSSProperties
}

export const ZKTab = ({
  tabs,
  tabClick,
  activeValue,
  customTabItem,
  wrapStyle,
  itemStyle = {},
  activeItemStyle = {},
  // itemActiveStyle = {},
  activeKey = 'value',
}: IProps) => {
  return (
    <ZKTabWrap style={wrapStyle}>
      {tabs.map((d, i) => {
        const isActive = d[activeKey] === activeValue
        const _itemStyle = Object.assign(
          {},
          itemStyle,
          isActive ? activeItemStyle : {},
        )
        return (
          <ZKTabItem
            style={_itemStyle}
            key={d.value + i}
            onClick={() => {
              if (typeof tabClick === 'function') {
                tabClick(d)
              }
            }}
            $active={isActive}
          >
            {customTabItem ? customTabItem(d) : d.label}
          </ZKTabItem>
        )
      })}
    </ZKTabWrap>
  )
}
